import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.adminOrganizations;
export const adminOrganizationsSelector = (state: RootState) => getState(state).data;
export const adminOrganizationsDataSelector = (state: RootState) =>
  adminOrganizationsSelector(state)?.tableData || [];
export const adminOrganizationsIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const adminOrganizationsErrorSelector = (state: RootState) => getState(state).error;
export const adminOrganizationActiveIdSelector = (state: RootState) =>
  getState(state).organizationId;
export const adminOrganizationDetailsSelector = (state: RootState) => getState(state).organization;
export const adminOrganizationDetailsIsLoadingSelector = (state: RootState) =>
  getState(state).organizationIsLoading;
export const adminOrganizationDetailsErrorSelector = (state: RootState) =>
  getState(state).organizationError;
export const adminOrganizationActivatingOrDeactivating = (state: RootState) =>
  getState(state).isActivatingOrDeactivating;
export const adminOrganizationCreatingNewSelector = (state: RootState) =>
  getState(state).isCreatingNew;
